<div class="container">
  <form #loginForm="ngForm">
    <div class="row justify-content-md-center mt-5">
      <div class="border border-primary rounded m-1 p-3 col-lg-6">
        <div class="form-group">
          <label for="user">Usuário</label>
          <input required id="user" name="user" type="text" class="form-control" name="user" [(ngModel)]="signInUser.login" (blur)="getUserClinics()" />
        </div>
        <div class="form-group">
          <label for="passwd">Senha</label>
          <input required id="passwd" name="passwd" type="password" class="form-control" name="passwd" [(ngModel)]="signInUser.password" />
        </div>
        <div class="form-group">
          <label for="clinic">Clínica</label>
          <select required [disabled]="selectClinicDisabled" id="clinic" name="clinic" class="form-control" [(ngModel)]="selectedClinic">
            <option *ngFor="let c of userClinics" [ngValue]="c">{{c.name}}</option>
          </select>
        </div>
        <button class="btn btn-primary float-right" [disabled]="!loginForm.form.valid" (click)="signingIn()">Entrar</button>
      </div>
    </div>
  </form>
</div>
